import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipMessageComponent } from './tip-message.component';
import { TagTextModule } from '../tag-text/tag-text.module';
import { PictureModule } from '../picture/picture.module';
import { VideoPlayerModule } from '../video-player/video-player.module';



@NgModule({
  declarations: [
    TipMessageComponent
  ],
  imports: [
    CommonModule,
    TagTextModule,
    PictureModule,
    VideoPlayerModule
  ],
  exports: [
    TipMessageComponent
  ]
})
export class TipMessageModule { }
